module.exports = __webpack_public_path__ + "img/qrcode.6dacf535.png";